module.exports = __webpack_public_path__ + "img/max-person-sync.895f98ea.svg";